import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./config";

const AuthContext = createContext({
  user: null,
  loading: true,
  login: async () => {},
  logout: () => {},
});

const TOKEN_KEY = "lb_auth_token";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Attach token to axios when present
  useEffect(() => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (t) api.defaults.headers.common.Authorization = `Bearer ${t}`;
  }, []);

  const fetchMe = useCallback(async () => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      api.defaults.headers.common.Authorization = `Bearer ${t}`;
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (_) {
      localStorage.removeItem(TOKEN_KEY);
      delete api.defaults.headers.common.Authorization;
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    const { access_token, user: u } = res.data;
    localStorage.setItem(TOKEN_KEY, access_token);
    api.defaults.headers.common.Authorization = `Bearer ${access_token}`;
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common.Authorization;
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY);
}
